import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import FounderPage from "../pages/founder/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/founder",
    element: <FounderPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
